import React, { useEffect, useState } from 'react';
import { useTableData } from './hooks/HData';
import GDataTable from '../tables/GDataTable';
import { CountryYieldCharts } from './charts/DataCharts';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MapTab from './MapTab';

interface DataTabProps {
    onTabClick?: (tab: string, data?: any) => void;
    [key: string]: any;
}

/**
 * DataTab - Displays table data fetched from the backend using HData hook
 * Allows user to specify table name and fetch data
 */
export default function DataTab({ onTabClick, ...props }: DataTabProps) {
    const [tabIndex, setTabIndex] = useState(0);
    const theme = useTheme();
    const tabSx = {
        color: '#123f6a', // slightly less dark navy when not selected
        '&.Mui-selected': {
            color: '#00A8FF', // electric blue when selected
        },
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const { data, loading, error, loadTableData } = useTableData('data');

    useEffect(() => {
        // Load data on mount with default table name
        loadTableData();
    }, [ loadTableData]);

 

    return (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h6" gutterBottom>
                Data Overview
            </Typography>

            <Tabs value={tabIndex} onChange={handleChange} sx={{ mb: 2 }}>
                <Tab label="Data" sx={tabSx} />
                <Tab label="Map" sx={tabSx} />
            </Tabs>

            {tabIndex === 0 && (
                <>
                    <CountryYieldCharts data={data} />
                    <GDataTable data={data} loading={loading} error={error} />
                </>
            )}

            {tabIndex === 1 && (
                <MapTab />
            )}
        </Box>
    );
}
